import { render } from "./SectionDivider.vue?vue&type=template&id=5f73c641"
import script from "./SectionDivider.vue?vue&type=script&lang=ts"
export * from "./SectionDivider.vue?vue&type=script&lang=ts"
script.render = render

export default script